import { openDB, deleteDB } from 'idb';
import { faker } from '@faker-js/faker';

export const dbService = {
    createDB, resetShipmentDb, resetMasterDataDb, resetCustomerDataDb
};

async function createDB() {
    // Using https://github.com/jakearchibald/idb
    const db = await openDB('dx', 7, {
        async upgrade(db, oldVersion, newVersion, transaction) {
            // Switch over the oldVersion, *without breaks*, to allow the database to be incrementally upgraded.
            console.log(oldVersion)
            console.log(newVersion)
            switch (oldVersion) {
                case 0:
                // Placeholder to execute when database is created (oldVersion is 0)
                case 1:
                    // Create a store of objects
                    let store = db.createObjectStore('customers', {
                        // The `id` property of the object will be the key, and be incremented automatically
                        autoIncrement: true,
                        keyPath: 'id'
                    });

                    store.createIndex('customerNumberIndex', 'customer_number');
                    store.createIndex('invoiceNumberIndex', 'invoice_number');

                    store = db.createObjectStore('sales', {
                        autoIncrement: true,
                        keyPath: 'id'
                    });

                    store.createIndex('customerNumberIndex', 'customerNumber');
                    store.createIndex('salesIdIndex', 'salesId');

                    store = db.createObjectStore('shipments', {
                        autoIncrement: true,
                        keyPath: 'id'
                    });
                    
                    store.createIndex('shipmentIdIndex', 'shipment_id');
                    store.createIndex('shipmentDriverIdIndex', 'driver_id');

                    store = db.createObjectStore('users', {
                        autoIncrement: true,
                        keyPath: 'id'
                    });
                    
                    store.createIndex('usernameIndex', 'username');
                    store.createIndex('emailIndex', 'email', {unique: false});

                    store = db.createObjectStore('session', {
                        autoIncrement: true,
                        keyPath: 'id'
                    });

                    store = db.createObjectStore('shipmentAction', {
                        autoIncrement: true,
                        keyPath: 'id'
                    });
                    
                    store.createIndex('shipmentIdIndex', 'shipment_id');
                    store.createIndex('orderIdIndex', 'order_id');
                    store.createIndex('statusIndex', 'status');
                    store.createIndex('syncedIndex', 'synced');
                    
                case 2:
                    console.log("Migrating to version 2")
                    let store2 = db.createObjectStore('items', {
                        // The `id` property of the object will be the key, and be incremented automatically
                        autoIncrement: true,
                        keyPath: 'id'
                    });
                    store2.createIndex('itemIdIndex', 'item_number');
                case 3:
                    console.log("Migrating to version 3")
                    store = db.createObjectStore('customerContacts', {
                        // The `id` property of the object will be the key, and be incremented automatically
                        autoIncrement: true,
                        keyPath: 'id'
                    });

                    store.createIndex('customerNumberIndex', 'customer_number');

                    store = db.createObjectStore('salesHistory', {
                        // The `id` property of the object will be the key, and be incremented automatically
                        autoIncrement: true,
                        keyPath: 'id'
                    });

                    store.createIndex('customerNumberIndex', 'customer_number');

                    store = db.createObjectStore('activities', {
                        // The `id` property of the object will be the key, and be incremented automatically
                        autoIncrement: true,
                        keyPath: 'id'
                    });

                    store.createIndex('customerNumberIndex', 'customer_number');
                    store.createIndex('activityNumberIndex', 'activity_number');
                    
                    store = db.createObjectStore('itemGroups', {
                        // The `id` property of the object will be the key, and be incremented automatically
                        autoIncrement: true,
                        keyPath: 'name'
                    });

                    store = db.createObjectStore('prospects', {
                        // The `id` property of the object will be the key, and be incremented automatically
                        autoIncrement: true,
                        keyPath: 'id'
                    });
                case 4:
                    console.log("Migrating to version 3")
                    db.createObjectStore('activityAction', {
                        autoIncrement: true,
                        keyPath: 'id'
                    });

                    db.createObjectStore('prospectAction', {
                        autoIncrement: true,
                        keyPath: 'id'
                    });
                case 5:
                    console.log("Migrating to version 5")
                    db.createObjectStore('customerNoteAction', {
                        autoIncrement: true,
                        keyPath: 'id'
                    });
                case 6:
                    console.log("Migrating to version 6")
                    db.createObjectStore('activityTypes', {
                        autoIncrement: true,
                        keyPath: 'id'
                    });
                case 7:
                    console.log("Migrating to version 7")
                    db.createObjectStore('salesPrices', {
                        autoIncrement: true,
                        keyPath: 'id'
                    });
            }
        }
    });

    return db;
}

export async function resetShipmentDb() {
    console.log("resetting shipments");
    let db = await createDB();
    db.clear("shipments");
}

export async function resetMasterDataDb() {
    console.log("resetting masterData");
    let db = await createDB();
    await db.clear("users");
    await db.clear("items");
}

export async function resetCustomerDataDb() {
    console.log("resetting masterData");
    let db = await createDB();
    await db.clear("customers");
    await db.clear("salesHistory");
    await db.clear("customerContacts");
    await db.clear("activities");
    await db.clear("itemGroups");
    await db.clear("prospects");
    await db.clear("activityTypes");
    await db.clear("salesPrices");
}
